<elder-basic-pane-layout class="full">
  <elder-pane class="p-md">
    <div class="gap-lg">
      <h2 class="text-title-large">{{ 'transit.title' | translate }}</h2>

      <div class="layout-row">
        <mat-form-field>
          <input matInput type="text" [(ngModel)]="prodOrderTransitIds" />
          <mat-label>{{ 'JSON Array of IDs' }}</mat-label>
        </mat-form-field>
        <button mat-menu-item (click)="emitProdOrderTransits(prodOrderTransitIds)">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Re-Emit ProdOrderTransit' | translate }}
        </button>
      </div>

      <h2 class="text-title-large">{{ 'positions.title' | translate }}</h2>
      <div class="layout-row">
        <mat-form-field>
          <elder-select appProcessPlanSelect valueAsId [(ngModel)]="sourceProcessPlanId">
          </elder-select>
          <mat-label>{{ 'ProcessPlan Source' }}</mat-label>
        </mat-form-field>
        <mat-form-field>
          <elder-select appProcessPlanSelect valueAsId [(ngModel)]="targetProcessPlanId">
          </elder-select>
          <mat-label>{{ 'ProcessPlan Target' }}</mat-label>
        </mat-form-field>
        <button mat-menu-item (click)="migrateWorkItemProcessPlanIds()">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Migrate OPEN WorkItem processPlan ids' | translate }}
        </button>
      </div>

      <div class="layout-row">
        <mat-form-field>
          <input matInput type="text" [(ngModel)]="workItemIds" />
          <mat-label>{{ 'JSON Array of IDs' }}</mat-label>
        </mat-form-field>
        <button mat-menu-item (click)="reEmitWorkItemIds(workItemIds)">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Re-emit items' | translate }}
        </button>
      </div>

      <div class="layout-row">
        <mat-form-field>
          <elder-select appFacilitySelect required valueAsId="true" [(ngModel)]="facility">
          </elder-select>
          <mat-label>{{ 'context.facility' | translate }}</mat-label>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>

        <button mat-menu-item (click)="retryPreparation()">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Prepare invalid items again' | translate }}
        </button>
      </div>

      <div class="layout-row">
        <mat-form-field>
          <elder-select appFacilitySelect required valueAsId="true" [(ngModel)]="facility">
          </elder-select>
          <mat-label>{{ 'context.facility' | translate }}</mat-label>
          <mat-error elderValidationError></mat-error>
        </mat-form-field>

        <button mat-menu-item (click)="retryEnrichments()">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Enrich invalid items again' | translate }}
        </button>
      </div>

      <h2 class="text-title-large">{{ 'packages.packages' | translate }}</h2>
      <div class="layout-row">
        <mat-form-field>
          <input matInput type="text" [(ngModel)]="workItemIds" />
          <mat-label>{{ 'JSON Array of IDs' }}</mat-label>
        </mat-form-field>
        <button mat-menu-item (click)="reEmitPackageIds(workItemIds)">
          <mat-icon color="warn">play_arrow</mat-icon>
          {{ 'Re-emit packages' | translate }}
        </button>
      </div>
    </div>
  </elder-pane>
</elder-basic-pane-layout>
